import { useRef } from "react";

interface Props {
  icon: string;
  title: string;
  subtitle?: string;
  value?: string;
  logged: boolean;
  onTap: () => void;
  onLongPress?: () => void;
}

export function LogRow({ icon, title, subtitle, value, logged, onTap, onLongPress }: Props) {
  const timer = useRef<number | null>(null);

  function start() {
    if (!onLongPress) return;
    timer.current = window.setTimeout(() => {
      timer.current = null;
      onLongPress();
    }, 300);
  }
  function cancel() {
    if (timer.current) { window.clearTimeout(timer.current); timer.current = null; }
  }
  function clicked() {
    if (timer.current) cancel();
    onTap();
  }

  return (
    <button
      onPointerDown={start}
      onPointerUp={cancel}
      onPointerLeave={cancel}
      onClick={clicked}
      className="w-full flex items-center gap-3 px-4 py-3 bg-surface rounded-2xl text-left active:bg-surface-strong transition-colors press"
    >
      <span aria-hidden="true" className="text-2xl leading-none w-7 text-center">{icon}</span>
      <div className="flex-1 min-w-0">
        <div className="font-medium truncate">{title}</div>
        {subtitle && <div className="text-sm text-fg-muted truncate">{subtitle}</div>}
      </div>
      {value && (
        <div className="text-sm font-semibold tabular-nums">
          {logged && <span aria-hidden="true" className="text-success mr-1">✓</span>}
          {value}
        </div>
      )}
      <span aria-hidden="true" className={`ml-2 h-6 w-6 rounded-full flex items-center justify-center text-sm ${
        logged ? "bg-success text-on-primary" : "bg-surface-strong text-fg-muted"
      }`}>
        {logged ? "✓" : "+"}
      </span>
    </button>
  );
}
